import { render, staticRenderFns } from "./SalesAccountDetail.vue?vue&type=template&id=080a38ac&"
import script from "./SalesAccountDetail.vue?vue&type=script&lang=js&"
export * from "./SalesAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports